import images from "./images";

const process = [
  {
    id: 1,
    image: images.step1,
    title: "Product Selection",
    content: "Choose from a variety of delicacies.",
  },
  {
    id: 2,
    image: images.step2,
    title: "Order Details",
    content: "Provide us with your order specifications.",
  },
  {
    id: 3,
    image: images.step3,
    title: "Payment",
    content: "Complete your payment using our payment gateway.",
  },
  {
    id: 4,
    image: images.step4,
    title: "Delivery",
    content: "Sit back & relax as we prepare your order.",
  },
];

export default process;